import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { ExpandMoreOutlined } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import SectionContainer from '../../components/SectionContainer';
import RevealOnScroll from '../../components/RevealOnScroll';

const FAQS = [
  {
    question: 'How long does onboarding take?',
    answer:
      'Usually 24–48 hours from the moment you submit the form. Our team helps you set up your gallery, courses, and batches.',
  },
  {
    question: 'Where do the leads come from?',
    answer:
      "Students actively studying at BookMyLibrary partner libraries across India. They're aspiring for exactly the exams you teach — the highest-intent segment in coaching.",
  },
  {
    question: 'What info do I get about each lead?',
    answer:
      'Full student name, phone, email, city, age, the courses they\'re interested in, any message they write, and their preferred batch start date — all the moment they submit.',
  },
  {
    question: 'How do I receive leads?',
    answer:
      'You get an in-app notification and web push alert on your manager dashboard the instant a student submits. Every lead lives in a pipeline (new → contacted → interested → enrolled) with notes and follow-up dates.',
  },
  {
    question: "What's the pricing?",
    answer:
      "Listing is completely free today. We're building a transparent performance-based model — you'll only ever pay when we deliver value. No upfront spend, no wasted budget.",
  },
  {
    question: 'Can I manage multiple branches?',
    answer:
      'Yes. Each branch is listed as its own institute with its own gallery, courses, batches, and lead pipeline. Manage everything from one owner account.',
  },
];

function FaqSection() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (_event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const borderColor = isDark ? 'rgba(255,255,255,0.08)' : 'rgba(27,54,93,0.08)';
  const accordionBg = isDark ? 'rgba(27,54,93,0.4)' : theme.palette.background.paper;

  return (
    <SectionContainer
      id="faq"
      eyebrow="Questions?"
      title="Frequently asked."
      subtitle="Can't find what you're looking for? Chat with us on WhatsApp."
    >
      <RevealOnScroll>
        <Box sx={{ maxWidth: 840, mx: 'auto' }}>
          {FAQS.map((faq, i) => (
            <Accordion
              key={faq.question}
              expanded={expanded === `panel${i}`}
              onChange={handleChange(`panel${i}`)}
              disableGutters
              elevation={0}
              sx={{
                background: accordionBg,
                border: `1px solid ${borderColor}`,
                borderRadius: '12px !important',
                mb: 1.5,
                '&:before': { display: 'none' },
                '&.Mui-expanded': {
                  border: `1px solid ${theme.palette.primary.main}40`,
                },
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreOutlined sx={{ color: theme.palette.primary.main }} />
                }
                aria-controls={`panel${i}-content`}
                id={`panel${i}-header`}
                sx={{ px: { xs: 2.5, md: 3 }, py: 0.5 }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}>
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: { xs: 2.5, md: 3 }, pb: 2.5 }}>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.75 }}>
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </RevealOnScroll>
    </SectionContainer>
  );
}

export default FaqSection;
